export class UnidadFuncional {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Numero: number | null,
    public readonly NumeroPartida: string | null,
    public readonly ConsorcioId: number | null,
    public readonly Consorcio: string | null,
    public readonly ComunidadId: number | null,
    public Comunidad: string | null,
    public readonly TipoUnidadId: number | null,
    public TipoUnidadNombre: string | null,
    public readonly TipoUnidadRequiereComunidad: boolean | null ,
    public readonly NroPiso: number | null,
    public readonly MetrosCuadradosCubiertos: number | null,
    public readonly MetrosCuadradosDescubiertos: number | null,
    public readonly CantidadAmbientes: number | null,
    public readonly FechaEntrega: Date | null,
    public readonly FechaEscrituracion: Date | null,
    public readonly MonedaId: number | null,
    public readonly Precio: number | null,
    public readonly ValuacionFiscal: number | null,
    public readonly Observaciones: string | null,
    public readonly Activo: boolean,
    public Adjuntos: UnidadFuncionalAdjunto[],
    public GastosPorcentajes: UnidadFuncionalGastosPorcentaje[]
  ) {}
}

export class SearchUnidadFuncionalRequest {
  constructor(
    public readonly PageSize: number | null,
    public readonly PageNumber: number | null,
    public readonly OrderAscending: boolean | null,
    public readonly OrderFieldName: string | null,
    public readonly Numero: number | null,
    public readonly Codigo: string | null,
    public readonly TipoUnidadId: number | null,
    public readonly PersonaId: number | null,
    public readonly UsuarioId: number | null,
    public readonly ConsorcioId: number | null,
    public readonly ComunidadId: number | null,
    public readonly ContratoId: number | null,
    public readonly VerSoloActivos: boolean | null
  ) {}
}

export class SaveUnidadFuncionalDto {
  constructor(
    public readonly Id: number,
    public readonly Codigo: string | null,
    public readonly Numero: number | null,
    public readonly NumeroPartida: string | null,
    public readonly TipoUnidadId: number | null,
    public readonly NroPiso: number | null,
    public readonly MetrosCuadradosCubiertos: number | null,
    public readonly MetrosCuadradosDescubiertos: number | null,
    public readonly CantidadAmbientes: number | null,
    public readonly FechaEntrega: Date | null,
    public readonly FechaEscrituracion: Date | null,
    public readonly MonedaId: number | null,
    public readonly Precio: number | null,
    public readonly ValuacionFiscal: number | null,
    public readonly Observaciones: string | null,
    public readonly Activo: boolean,
  ) {}
}

export class SearchUnidadFuncionalResponse {
  constructor(
    public readonly count: number,
    public readonly result: UnidadFuncional[]
  ) {}
}

export class UploadUnidadFuncionalAttachResponseDto {
  constructor (
      public readonly Archivos: UnidadFuncionalAdjunto[]
  ) {}
}

export class UnidadFuncionalAdjunto {
  constructor (
      public readonly Id: number,
      public readonly NombreDocumento: string | null,
      public readonly UrlDocumento: string | null,
      public readonly UnidadFuncionalId: number
  ) {}
}

export class UnidadFuncionalGastosPorcentaje {
  constructor (
    public readonly Id: number,
    public TipoGastoId: number,
    public TipoGasto: string | null,
    public Porcentaje: number,
    public PorcentajeAcumulado: number,
    public readonly UnidadFuncionalId: number,
    public readonly UnidadFuncionalCodigo: string | null,
    public readonly UnidadFuncionalNumero: number | null,
    public readonly UnidadFuncionalTipo: string
  ) {}
}

export class UnidadFuncionalRelacionesRequestDto {
  constructor (
      public readonly ComunidadId: number
  ) {}
}

export class UnidadFuncionalRelacionesResponseDto {
  constructor (
    public readonly UnidadFuncionalId: number,
    public readonly UnidadFuncionalCodigo: string | null,
    public readonly UnidadFuncionalNumero: number,
    public readonly TipoUnidad: string | null,
    public Relaciones: UnidadFuncionalPersona[]
  ) {}
}

export class UnidadFuncionalPersona {
  constructor(
    public readonly Id: number,
    public readonly UnidadFuncionalId: number,
    public readonly UnidadFuncionalNumero: number,
    public readonly PersonaId: number,
    public readonly PersonaNombre: string | null,
    public readonly PersonaApellido: string | null,
    public readonly PersonaMailContacto: string | null,
    public readonly FechaEnvioMailInvitacion: string | null,
    public readonly TipoRelacionId: number,
    public readonly TipoRelacionNombre: string | null,
    public readonly PuedeEnviarInvitacion: boolean,
    public readonly EnviarExpensa: boolean,
    public readonly EnviarExpensaTexto: string
  ) {}
}

export class SaveUnidadFuncionalPersonaRelacionDto {
  constructor (
    public readonly UnidadFuncionalId: number,
    public readonly UnidadFuncionalCodigo: string | null,
    public readonly UnidadFuncionalNumero: number,
    public readonly TipoUnidad: string | null,
    public Relaciones: SaveUnidadFuncionalPersona[]
  ) {}
}

export class SaveUnidadFuncionalPersona {
  constructor(
    public readonly Id: number,
    public readonly UnidadFuncionalId: number | null,
    public readonly UnidadFuncionalNumero: number | null,
    public PersonaId: number | null,
    public readonly PersonaNombre: string | null,
    public readonly PersonaApellido: string | null,
    public readonly PersonaMailContacto: string | null,
    public readonly TipoRelacionId: number | null,
    public readonly TipoRelacionNombre: string | null,
    public PuedeEnviarInvitacion: boolean,
    public EnviarInvitacion: boolean,
    public EnviarExpensa: boolean,
    public EnviarExpensaTexto: string | null,
    public Cambio: boolean | null
  ) {}
}

export class DialogUnidadFuncionalSearchComponentRequestDto {
  constructor(
      public readonly AllowMultipleSelection: boolean,
      public readonly MaxItemSelection: number,
      public readonly Filters: any
  ) { }
}

export class DialogUnidadFuncionalSearchComponentResponseDto {
  constructor(
      public readonly Cancelled: boolean,
      public readonly Items: UnidadFuncional[]
  ) { }
}

export class DialogUnidadFuncionalGestionRequestDto {
  constructor(
    public readonly Id: number,
    public readonly PreloadedData: any
  ) { }
}

export class DialogUnidadFuncionalGestionResponseDto {
  constructor(
      public readonly Cancelled: boolean,
      public readonly Item: UnidadFuncional | null
  ) { }
}

export class ImportUnidadFuncionalExcelRequestDto {
  constructor(
    public NombreArchivo: string | null,
    public Archivo: any
  ) {}
}

export class ImportUnidadFuncionalPersonaExcelRequestDto {
  constructor(
    public NombreArchivo: string | null,
    public Archivo: any,
    public ComunidadId: number,
    public relacionesPrevias: SaveUnidadFuncionalPersonaRelacionDto[]
  ) {}
}
